import Swiper from "swiper";
import { Navigation } from "swiper/modules";

export const init = () => {
  if (!document.querySelector(".swiper-home-clients")) return;

  const swiperHomeClients = new Swiper(".swiper-home-clients", {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 32,
    loop: true,
    navigation: {
      enabled: true,
      nextEl: ".home-clients__next",
      prevEl: ".home-clients__prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 8,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 16,
        navigation: {
          enabled: false,
        },
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 32,
        navigation: {
          enabled: false,
        },
      },
    },
  });
};
